<script>
    import { eventBus } from '../../../../assets/eventBus';
    import { piniaPlugin } from '../../../../stores';
    import Button from '../../../../components/buttons/Button.vue';
    import FormFileMultipleInput from '../../../../components/forms/FormFileMultipleInput.vue';
    import FormModal from '../../../../components/modals/FormModal.vue';
    import axios from "axios";
    import { Inertia } from '@inertiajs/inertia';
    import MainCollapsible from './components/MainCollapsible.vue';

    export default {
        components: {
            Button, FormFileMultipleInput, FormModal, MainCollapsible
        },
        props: {
            sidebarFolders: {
                type: Array,
                default: () => [],
                required: true,
            },
            folderIdsArray: {
                type: Array,
                default: [],
            },
            selectedFolderId: {
                type: [Number, String]
            },
            dataType: {
                type: String,
                default: 'Own'
            },
            uploadFilePermission: {
                type: Number,
                default: 0
            },
            folderType: {
                type: String,
                default: null,
                required: true,
            },
            insideFolderID: {
                type: String,
                default: null
            },
            sharedType: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                addOption: (this.folderType === 'OwnContent' || this.folderType === 'Own') && this.uploadFilePermission ? true : false,
                isShowModal: false,
                addFolderData: {
                    doc_name: null,
                    is_add_folder: true,
                    folder_id: null
                },
                addFolderButtonText: 'Add',
                isAddFolderButtonLoading: false,
                uploadFileData: {
                    attachment: null,
                    old_folder_id: null,
                },
                allFolders: [],
                folderLoader: true,
                uploadFileButtonText: 'Upload File',
                isUploadFileButtonLoading: false,
                errors: {},
                modalTitle: null,
                showError: null,
                modalDataType: null,
                isFileError: false,
                click: 0,
                folderContentUrl: null,
                modalItems: {},
                isLoading: true
            }
        },
        setup() {
            const store = piniaPlugin();
            return { store };
        },
        computed: {
            // Example admin, sb, tc, tp
            userTypeAbbr() {
                return this.$page.props.auth.user.user_type_abbr;
            },
            isLockedAcc() {
                return this.$page.props.auth.user.is_it_locked_account;
            },
            isPaidAcc() {
                return this.$page.props.auth.user.login_user_is_paid;
            },
            userType() {
                return this.$page.props.auth.user.user_type;
            }
        },
        methods: {
            addModal(modalType) {
                this.modalDataType = modalType
                this.modalTitle = modalType === 'folder' ? 'Create new folder' : 'Upload File'
                this.errors = {}
                this.isShowModal = true
                this.addFolderData.folder_id = this.insideFolderID
                this.uploadFileData.old_folder_id = this.insideFolderID
                if(this.folderType === 'Own' || this.folderType === 'OwnContent') {
                    this.folderLoader = true
                    axios.post(route('get-folder-list-by-type'), { 
                        type: 'forUploadFile',
                        parentFolderId: this.addFolderData.folder_id
                    }, {})
                    .then(response => {
                        this.folderLoader = false
                        this.allFolders = response.data.data;
                    })
                    .catch(err => {
                        this.folderLoader = false
                        this.allFolders = [];
                    });
                }
            },
            hideModal(){
                this.uploadFileData.attachment = null
                this.isFileError = false
                this.isShowModal = false
                this.modalDataType = null
            },
            addFolder() {
                this.errors = {}
                this.addFolderButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`;
                this.isAddFolderButtonLoading = true
                this.$refs.topProgress.start()
                axios.post(
                route(this.userTypeAbbr + '-vault-document-create'),
                this.addFolderData, {
                })
                .then(response => {
                    this.$toastr.s(response.data.message);
                    this.addFolderButtonText = 'Add'
                    this.hideModal();
                    this.isAddFolderButtonLoading = false
                    eventBus.reloadFolderFile('Add', 'folders')
                    this.addFolderData.doc_name = null
                    this.$refs.topProgress.done()
                })
                .catch(err => {
                    this.addFolderButtonText = 'Add'
                    this.isAddFolderButtonLoading = false
                    if(err.response.status == 401) {
                        this.errors = {
                            ...this.errors,
                            doc_name: err.response.data.message
                        }
                    } else {
                        this.$toastr.e(err.response.data.message);
                    }
                    this.$refs.topProgress.done()
                });
            },
            uploadFile() {
                this.errors = {}
                this.uploadFileButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`;
                this.isUploadFileButtonLoading = true
                let multiFiles = this.$refs.fileupload.fileUpload();
            
                let formData = new FormData()
                /*
                    Add the form data we need to submit
                */
                formData.append('old_folder_id', this.uploadFileData.old_folder_id)
                for(let i = 0; i < multiFiles.length; i++) {
                    formData.append('attachment[]', multiFiles[i])
                }
                this.$refs.topProgress.start()
                axios.post(
                route(this.userTypeAbbr + '-vault-document-create'),
                formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    if(response.data.successcount > 0) {
                        this.$toastr.s(response.data.successmessage);
                    }
                    this.$refs.fileupload.$refs.showfilesname.innerHTML = ''
                    if(response.data.errormessage.length > 0) {
                        this.showError = ''
                        for(let i of response.data.errormessage) {
                            this.showError += '<i class="mdi mdi-circle-medium"></i> ' + i + '<br>'
                        }
                        this.$refs.fileupload.showError(this.showError);
                        this.isFileError = true
                    }
                    if(!this.isFileError) {
                        this.hideModal();
                    }
                    this.isFileError = false
                    this.uploadFileButtonText = 'Upload File'
                    this.isUploadFileButtonLoading = false
                    eventBus.reloadFolderFile('Add', 'files')
                    this.uploadFileData.attachment = null
                    this.$refs.topProgress.done()
                })
                .catch(err => {
                    this.uploadFileButtonText = 'Upload File'
                    this.isUploadFileButtonLoading = false
                    if(err.response.status == 401) {
                        if(err.response.data.message) {
                            this.errors = {
                                ...this.errors,
                                attachment: err.response.data.message
                            }
                        } else {
                            this.errors = {
                                ...this.errors,
                                old_folder_id: err.response.data.message1
                            }
                        }

                        this.$refs.fileupload.$refs.showfilesname.innerHTML = ''
                        if(err.response.data.errorfiles != undefined) {
                            if(err.response.data.errorfiles.length > 0) {
                                this.showError = ''
                                for(let i of err.response.data.errorfiles) {
                                    this.showError += '<i class="mdi mdi-circle-medium"></i> ' + i + '<br>'
                                }
                                this.$refs.fileupload.showError(this.showError)
                            }
                        }
                    } else {
                        this.$toastr.e(err.response.data.message);
                    }
                    this.$refs.topProgress.done()
                });
            },
            checkClickEvent(item, event, value = 0) {
                let val = 1
                if (value == 0) {
                    this.click += val
                }

                this.folderContentUrl = this.dataType == 'Own' ? route(this.userTypeAbbr + '-folder-content', { id: item.encryptedId}) : route(this.userTypeAbbr + '-shared-folder-content', [item.encryptedId, item.docType]);

                setTimeout(() => {
                    let folderLength = item.name.length;
                    let isNameTruncated = false;
                    if (value == 1) {
                        isNameTruncated = event.target.innerHTML.split(" ").includes("...");
                    }

                    if (this.click == 1 && value == 1 && folderLength > 20 && isNameTruncated) {
                        event.target.innerHTML = item.name;
                    }
                    else {
                        if (this.click == 1) {
                            if ((('protected' in item) && item.protected) || (('hasPassword' in item) && item.hasPassword)) {
                                this.modalItems = {
                                    ...this.modalItems,
                                    id: item.id,
                                    name: item.name,
                                    dataType: 'folders',
                                    viewUrl: this.folderContentUrl
                                }
                                eventBus.openUnlockModal(this.modalItems)
                                this.modalItems = {}
                            }
                            else {
                                if(!item.isDefault) {
                                    localStorage.getID = JSON.stringify(item.id);
                                    Inertia.visit(this.folderContentUrl);
                                    this.folderContentUrl = null
                                }
                            }
                        }
                    }
                    this.click = 0
                }, 300)
            },
            checkRecursiveTreeHasId(item) {
                if (item.hasOwnProperty('recursive_tree')) {
                    const status = item.recursive_tree.length ? item.recursive_tree.some((child) => this.checkRecursiveTreeHasId(child)) : false;
                    if (status) {
                        return true;
                    }
                    return this.dataType == 'Shared' ? (item.id == this.selectedFolderId && item.docType == this.sharedType) : item.id == this.selectedFolderId;
                } else {
                    return this.dataType == 'Shared' ? (item.id == this.selectedFolderId && item.docType == this.sharedType) : item.id == this.selectedFolderId;
                }
            }
        },
        mounted() {
            let self = this
            eventBus.$on('isSideBarLoading', (value) => {
                    self.isLoading = value;
            });
            Inertia.on('invalid', (event) => {
                event.preventDefault()
            })
        }
    };
</script>

<template>
    <div class="card filemanager-sidebar me-md-2">
        <vue-topprogress ref="topProgress" :height="2"></vue-topprogress>
        <div class="card-body">
            <div class="d-flex flex-column h-100">
                <div class="mb-4">
                    <div v-if="store.useMultiSelect.isShowActionButton" class="mb-2 mt-1 d-grid" :class="{'zoomInEffect': store.useMultiSelect.isShowActionButton}" title="Actions">
                        <b-dropdown variant="success" toggle-class="btn-block">
                            <template #button-content>
                                <div class="d-flex flex-row align-items-center justify-content-center gap-2"> 
                                    <span>Actions</span>
                                    <i class="mdi mdi-arrow-down-drop-circle-outline me-1"></i>
                                </div>
                            </template>
                            <template v-if="folderType === 'Own' || folderType === 'OwnContent'">
                                <b-dropdown-item @click="store.useMoveStore.showMoveModal(null)" href="Javascript:void(0)">Move</b-dropdown-item>
                                <template v-if="userType != 4">
                                    <b-dropdown-item @click="store.useDeleteStore.multipleDeleteFolderFile(userTypeAbbr)" href="Javascript:void(0)">Delete</b-dropdown-item>
                                </template>
                            </template>
                            <b-dropdown-item @click="store.useDownloadStore.downloadFoldersFiles()" href="Javascript:void(0)">Download</b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <div v-if="addOption && !isLockedAcc && isPaidAcc" class="mb-3 mt-1 d-grid" title="Create New">
                        <b-dropdown toggle-class="w-100 btn-block" variant="success">
                            <template #button-content>
                                <i class="mdi mdi-plus me-1"></i> Create New
                            </template>
                            <b-dropdown-item href="Javascript:void(0)" @click="addModal('folder')">
                                <i class="bx bx-folder me-1"></i>
                                Folder
                            </b-dropdown-item>
                            <b-dropdown-item href="Javascript:void(0)" @click="addModal('file')">
                                <i class="bx bx-file me-1"></i> File
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <ul class="list-unstyled categories-list">
                        <li>
                            <div class="custom-accordion">
                                <Link
                                    :href="route(userTypeAbbr + '-document-manager')"
                                    class="text-body fw-medium py-1 d-flex align-items-center"
                                    data-toggle="collapse"
                                    v-b-toggle.categories-collapse
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls="categories-collapse"
                                >
                                    <i class="mdi mdi-folder font-size-16 me-2 text-warning"></i>
                                        My Folders
                                    <i class="mdi accor-down-icon ms-auto" :class="dataType == 'Own' ? 'mdi-chevron-up' : 'mdi-chevron-down'"></i>
                                </Link>
                                <MainCollapsible
                                    v-if="dataType == 'Own'" 
                                    :isLoading="isLoading"
                                    :sidebarFolders="sidebarFolders"
                                    :dataType="dataType"
                                    :selectedFolderId="selectedFolderId"
                                    :sharedType="sharedType"
                                    :folderIdsArray="folderIdsArray"
                                    :checkClickEvent="checkClickEvent"
                                    :checkRecursiveTreeHasId="checkRecursiveTreeHasId"
                                />
                                <Link
                                    :href="route(userTypeAbbr + '-shared-document-manager')"
                                    class="text-body fw-medium py-1 d-flex align-items-center"
                                    data-toggle="collapse"
                                    v-b-toggle.categories-collapse
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls="categories-collapse"
                                >
                                    <i class="mdi mdi-folder font-size-16 me-2 text-primary"></i>
                                        Shared Folders
                                    <i class="mdi accor-down-icon ms-auto" :class="dataType == 'Shared' ? 'mdi-chevron-up' : 'mdi-chevron-down'"></i>
                                </Link>
                                <MainCollapsible 
                                    v-if="dataType == 'Shared'"
                                    :isLoading="isLoading"
                                    :sidebarFolders="sidebarFolders"
                                    :dataType="dataType"
                                    :selectedFolderId="selectedFolderId"
                                    :sharedType="sharedType"
                                    :folderIdsArray="folderIdsArray"
                                    :checkClickEvent="checkClickEvent"
                                    :checkRecursiveTreeHasId="checkRecursiveTreeHasId"
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <FormModal
            :isShow="isShowModal"
            :isButtonLoading="modalDataType === 'folder' ? isAddFolderButtonLoading : isUploadFileButtonLoading"
            :title="modalTitle"
            :isShowSubmitButton="true"
            :clickSubmitButton="modalDataType === 'folder' ? addFolder : uploadFile"
            :submitButtonText="modalDataType === 'folder' ? addFolderButtonText : uploadFileButtonText"
            :isShowCancelButton="true"
            @hideModal="hideModal"
        >
            <div class="row">
                <div class="col-12">
                    <template v-if="modalDataType === 'folder'">
                        <div v-if="folderType === 'Own' || folderType === 'OwnContent'" class="mb-3">       
                            <div class="input-group"> 
                                <input
                                    @keyup.enter="addFolder" 
                                    type="text" 
                                    placeholder="Folder Name" 
                                    class="form-control" 
                                    v-model='addFolderData.doc_name'
                                    name="doc_name" 
                                    :class="{
                                        'is-invalid': errors.doc_name
                                    }"
                                />
                                <div
                                    v-if="errors.doc_name"
                                    class="invalid-feedback"
                                >
                                    {{ errors.doc_name }}
                                </div>
                            </div>
                        </div>         
                    </template>
                    <template v-else>
                        <form ref="uploadFileForm" enctype="multipart/form-data">
                            <div class="mb-3">
                                <label>
                                    Choose multiple files (Maximum 500MB).
                                    <a
                                        class="text-info"
                                        id="tooltip-target-1"
                                        style="cursor: pointer"
                                    >
                                        Supported formats?
                                    </a>
                                </label>  
                                <b-tooltip
                                    target="tooltip-target-1"
                                    triggers="hover"
                                >
                                    jpeg, png, jpg, docx, doc, pdf,
                                    xlsx, xlsm, xlsb, xltx, xltm, xls,
                                    xlt, xml, xlam, xla, xlw, xlr, prn,
                                    txt, csv, xlc, xld, xlk, dif, ods,
                                    slk, xps, dbf, pptx, pptm, ppt,
                                    potx, potm, pot, thmx, ppsx, ppsm,
                                    pps, ppam, ppa, mp4, mov, wmv, gif,
                                    tif, bmp, wmf, emf, rtf, odp, zip
                                </b-tooltip>
                                <FormFileMultipleInput ref="fileupload"
                                    :isShowLabel="false" 
                                    v-model='uploadFileData.attachment'
                                    :required="false"
                                    :error="errors.attachment"
                                    name="attachment"
                                />
                                <div
                                    v-if="errors.attachment"
                                    class="invalid-feedback"
                                >
                                    {{ errors.attachment }}
                                </div>
                            </div>
                            <template v-if="folderType === 'Own' || folderType === 'OwnContent'">
                                <div v-if="folderLoader" class="text-center">
                                    <div class="spinner-border text-success m-3" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                                <div v-else class="mb-3">
                                    <label for="folder">Choose folder to import file</label>
                                    <b-form-select v-model="uploadFileData.old_folder_id" class="form-control" :class="{'is-invalid': errors.old_folder_id}">
                                        <b-form-select-option :value="null">Please select a folder</b-form-select-option>
                                        <b-form-select-option v-for="(item, index) in this.allFolders" :value="item.id" :key="index">
                                            {{ item.document_name }}
                                        </b-form-select-option>
                                    </b-form-select>
                                    <div
                                        v-if="errors.old_folder_id"
                                        class="invalid-feedback"
                                    >
                                        {{ errors.old_folder_id }}
                                    </div>
                                </div> 
                            </template>
                        </form>      
                    </template>
                </div>
            </div>
        </FormModal>
    </div>
</template>
<style scoped>
    .fixedHeightAutoScroll {
        height: 575px;
        overflow-y: auto;
    }
    .fixedWidthText {
        min-width:5.2em;
    }
    .zoomInEffect {
        opacity: 1;
        animation: zoominanimation ease 0.5s;
    }
    @keyframes zoominanimation {
        0% {
            opacity: 0;
            scale: 0;
        }
        100% {
            opacity: 1;
            scale: 1;
        }
    }
</style>